import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    optionalBoolean,
    optionalString,
    optionalUuid,
    optionalNumber,
    requiredNumber,
    requiredUuid,
} from './fields';
import { SYNC_UPDATE_VALIDATION_SCHEMA } from './common';

export const createUsersAddSchema = () =>
    z.object({
        id: requiredUuid(),
        created_at: requiredNumber(),
        updated_at: requiredNumber(),
        email: optionalString(),
        password_digest: optionalString(),
        reset_password_token: optionalString(),
        api_refresh_token: optionalString(),
        accounting_disconnect_message: optionalString(),
        region: optionalString(),
        sales_account_code: optionalString(),
        lock_accounting_provider: optionalBoolean(),
        menu_order: optionalString(),
        is_team_created: optionalBoolean(),
        is_procedures_account_setup_set: optionalBoolean(),
        is_invoicing_account_setup_set: optionalBoolean(),
        is_contacts_setup_set: optionalBoolean(),
        is_contacts_setup: optionalBoolean(),
        is_appointment_onboarded: optionalBoolean(),
        ignore: optionalBoolean(),
        is_appointment_contact_selection_onboarded: optionalBoolean(),
        is_entry_creation_from_event_enabled: optionalBoolean(),
        terms_accepted_at: optionalNumber(),
        terms_created_at: optionalNumber(),
        is_plus_button_onboarded: optionalBoolean(),
        location_id: optionalUuid(),
        first_name: optionalString(),
        last_name: optionalString(),
        phone: optionalString(),
        phone_prefix: optionalString(),
        accounting_provider: optionalString(),
        address: optionalString(),
        trace_id: optionalUuid(),
        profiling: optionalBoolean(),
        company_name: optionalString(),
        freshchat_restore_id: optionalString(),
        timezone: optionalString(),
    });

export const createUsersUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createUsersAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.users,
    );

export const createUsersDeleteSchema = () => createDeleteSchema();

export const createUsersSchemas = () => ({
    add: createUsersAddSchema(),
    update: createUsersUpdateSchema(),
    delete: createUsersDeleteSchema(),
});
